import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import { Report } from '@/types/report';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  reportType: string;
  startDate: string;
  endDate: string;
  format: string;
  timezone: string;
};

export const createReport = async (
  scope: RequestScope,
  { reportType, startDate, endDate, format, timezone }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Report>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Report>>(
      `reports/${encodeURIComponent(reportType)}`,
      {},
      { ...options, params: { start_date: startDate, end_date: endDate, format, tz: timezone } }
    );
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e, { redactRequestData: true });
  }
};
